import React from "react";
import { colors } from "../../utils/constants";
import FormErrorMessage from "../FormErrorMessage";
import SearchIcon from "@mui/icons-material/Search";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/store";
import { toggle } from "../../redux/slices/passwordVisibilitySlice";
interface TextInputPropType {
  onChangeFunc: (e: React.ChangeEvent<any>) => void;
  value: string;
  placeholder?: string;
  isRequired?: boolean;
  errorMsg?: string;
  isPassword?: boolean;
  name?: string;
  label?: string;
  isError?: boolean;
  autoFocus?: boolean;
  maxLength?: number | undefined;
  isFocused?: boolean;
  onFocus?: (e: React.FocusEvent<any>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => void;
  isTextArea?: boolean;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  extraInputClass?: string;
  onClick?: (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  disabled?: boolean;
  showCounter?: boolean;
  counterMessage?: string;
  isNumber?: boolean;
  readonly?: boolean;
  isSearchInput?: boolean;
  isDarkBg?: boolean;
  subLabel?: string;
  isTransparent?: boolean;
}
const TextInput = ({
  onChangeFunc,
  value = "",
  label = "",
  placeholder = "",
  isRequired = false,
  errorMsg = "",
  isPassword = false,
  name = "",
  isError = false,
  autoFocus = false,
  isFocused = false,
  maxLength,
  onFocus = () => {},
  isTextArea = false,
  onBlur = () => {},
  onKeyUp = () => {},
  extraInputClass = "",
  onClick = () => {},
  disabled = false,
  showCounter = false,
  counterMessage = "",
  isNumber = false,
  readonly,
  isSearchInput = false,
  isDarkBg = false,
  subLabel = "",
  isTransparent = false,
}: TextInputPropType) => {
  const dispatch = useDispatch();
  const showPassword = useSelector((state: RootState) => state.passwordVisibility[name || "default"] || false);

  const renderVisibilityIcon = () => {
    const Icon = showPassword ? RemoveRedEyeOutlinedIcon : VisibilityOffOutlinedIcon;
    return <Icon className="!text-lg" />;
  };
  return (
    <>
      {subLabel ? (
        <label className="text-[16px] text-docsigna-blue-dark font-bold block w-full max-w-full mb-4">
          {subLabel}
          <span className="text-red-500">*</span>
        </label>
      ) : null}
      {label ? (
        <label className="text-sm text-docsigna-blue-dark font-medium block w-full max-w-full mb-1">
          {label}
          {isRequired && !disabled ? <span className="text-red-500">*</span> : null}
        </label>
      ) : null}
      <div className="block w-auto max-w-full relative">
        {isTextArea ? (
          <textarea
            name={name}
            ref={textInput => (isFocused ? textInput?.focus() : null)}
            autoFocus={autoFocus}
            className={`text-base text-docsigna-blue-dark !font-medium block w-full rounded-md shadow-none border border-docsigna-blue-dark placeholder-gray-400 ${extraInputClass} ${
              isTransparent ? "bg-transparent" : isDarkBg ? "bg-docsigna-pink-light" : ""
            }`}
            placeholder={placeholder}
            onChange={onChangeFunc}
            value={value}
            maxLength={maxLength}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyUp={onKeyUp}
            disabled={disabled}
            readOnly={readonly}
          />
        ) : (
          <div className={isPassword ? "relative" : ""}>
            <input
              name={name}
              autoComplete="off"
              ref={textInput => {
                isFocused && textInput?.focus();
              }}
              autoFocus={autoFocus}
              type={isPassword ? (showPassword ? "text" : "password") : isNumber ? "number" : "text"}
              className={`block w-full text-docsigna-blue-dark font-medium leading-none rounded-md shadow-none border border-docsigna-blue-dark p-2.5 ${extraInputClass} ${
                isSearchInput ? "pl-8" : ""
              } ${isTransparent ? "bg-transparent" : isDarkBg ? "bg-docsigna-pink-light" : ""} ${isPassword ? "pr-10" : ""}`}
              placeholder={placeholder}
              inputMode="text"
              onChange={onChangeFunc}
              value={value}
              maxLength={maxLength}
              onFocus={onFocus}
              onBlur={onBlur}
              onClick={onClick}
              onKeyUp={onKeyUp}
              disabled={disabled}
              readOnly={readonly}
              onWheel={isNumber ? e => e.currentTarget.blur() : undefined}
              onKeyDown={
                isNumber
                  ? e => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }
                    }
                  : undefined
              }
            />
            {isPassword && (
              <span onClick={() => dispatch(toggle(name || "default"))} className="absolute right-3 top-2 cursor-pointer">
                {renderVisibilityIcon()}
              </span>
            )}
          </div>
        )}
        {showCounter ? <p className="block text-sm text-gray-500 text-right">{`${value.length} / ${counterMessage}`}</p> : null}
        {isError ? <FormErrorMessage text={errorMsg} /> : <p></p>}
        {isSearchInput ? (
          <div className="absolute top-0 bottom-0 left-3 flex items-center">
            <SearchIcon htmlColor={colors.CyanBlue} style={{ fontSize: "18px", marginTop: "2px" }} />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default TextInput;
